
import { DatePicker, Icon, Popover, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
const { RangePicker } = DatePicker;
const { Option } = Select;




const CustomHeader = ({ headers,
    colDef,
    field,
    sortOrder,
    handleSort,
    handleFilter,
    renderFilter,
    inputType,
    options = [],
    showPopOver,
    handleFilterResetHandler,
    placeholder = "Type to filter...",
    defaultFilterContentWidth = 180
}) => {
    const [filterValue, setFilterValue] = useState('');
    const [visible, setVisible] = useState(false);
    const [dateRange, setDateRange] = useState([moment("2010-01-01"), moment("2050-01-01")]);



    useEffect(() => {
        if (handleFilterResetHandler) {
            handleFilterResetHandler(() => {
                setFilterValue('');
                setDateRange([moment("2010-01-01"), moment("2050-01-01")])
            });
        }
    }, []);



    const onFilterChange = (e, option = null) => {
        let value;

        if (e && e.target) {
            const { type, value: targetValue, checked } = e.target;
            value = type === "checkbox" ? checked.toString() : targetValue;
        } else {
            value = e;
        }

        setFilterValue(value);

        if (handleFilter && field) {
            handleFilter(field, value, inputType);
        }
    };



    const defaultFilterContent = (() => {
        switch (inputType) {
            case "date":
                const dateFormat = 'MM-DD-YYYY';
                const defaultStart = moment('2010-01-01', 'YYYY-MM-DD');
                const defaultEnd = moment('2050-01-01', 'YYYY-MM-DD');
                return (
                    <div onClick={(e) => e.stopPropagation()} >
                        <RangePicker
                            getCalendarContainer={() => document.body}
                            className='custom-datepicker'
                            format={dateFormat}
                            value={dateRange}
                            onChange={(dates) => {
                                setDateRange(dates);
                                if (dates && dates.length === 2) {
                                    const [start, end] = dates;
                                    const range = {
                                        start_date: start.format(dateFormat),
                                        end_date: end.format(dateFormat),
                                    };
                                    onFilterChange(range);
                                } else {
                                    onFilterChange(null);
                                }
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                );

            case "select":
                return (
                    <div onClick={(e) => e.stopPropagation()} >
                        <Select
                            value={filterValue ? filterValue : undefined}
                            allowClear
                            showSearch
                            onChange={onFilterChange}
                            className='dropDown custom-select'
                            placeholder="Select"
                            optionFilterProp="children"
                            getPopupContainer={() => document.body}
                            filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toLowerCase().includes(input.toLowerCase())
                            }
                            dropdownStyle={{
                                maxHeight: 'auto',
                                overflowY: 'hidden',
                                overflowX: 'hidden',
                            }}
                        >
                            {options.map((opt, i) => (
                                <Option key={i} value={opt.id} style={{ fontSize: '12px' }}>
                                    {opt.name}
                                </Option>
                            ))}
                        </Select>
                    </div>
                );
            case "checkbox":
                return (
                    <label style={{ fontSize: "12px" }}>
                        <input
                            type="checkbox"
                            checked={filterValue === "true"}
                            onChange={onFilterChange}
                            onClick={(e) => e.stopPropagation()}
                        />
                        Show Checked
                    </label>
                );
            case 'text':
                return (
                    <input
                        type="text"
                        value={filterValue}
                        onChange={onFilterChange}
                        placeholder={placeholder}
                        style={{
                            padding: "4px 8px",
                            fontSize: "12px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: `${defaultFilterContentWidth}px`,  // dynamic width
                            minWidth: "150px",                     // fallback minimum
                            maxWidth: "100%"                       // prevent overflow
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                );
            case "multiCheckbox":
                return (
                    <Checkbox.Group
                        value={filterValue}
                        onChange={onFilterChange}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '8px 12px',
                            maxHeight: '160px',
                            overflowY: 'auto',
                            background: '#fff',
                            border: '1px solid #d9d9d9',
                            borderRadius: '6px',
                            fontSize: '13px'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {options.map((opt, i) => (
                            <Checkbox key={i} value={opt.id} style={{ marginBottom: '6px' }}>
                                {opt.name}
                            </Checkbox>
                        ))}
                    </Checkbox.Group>
                );

            default:
                return (
                    <input
                        type="text"
                        value={filterValue}
                        onChange={onFilterChange}
                        placeholder="Type to filter..."
                        style={{
                            padding: "4px 8px",
                            fontSize: "12px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            width: "150px"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                );
        }
    })();


    const commonStyle = {
        padding: "4px 8px",
        fontSize: "12px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        width: "150px",
    };


    const filterContent = renderFilter
        ? renderFilter({ filterValue, setFilterValue, onFilterChange, field })
        : defaultFilterContent;


    const handleKeyDown = (e) => {
        if (e.key === " " && e.target === e.currentTarget && handleSort && field) {
            e.preventDefault();  // Prevent space from being typed if we're in the header area
            handleSort(field);   // Trigger sorting
        }

        // if ((e.key === "Enter" || e.key === " ") && handleSort && field) {
        if ((e.key === "Enter") && handleSort && field) {
            e.preventDefault();
            handleSort(field);
        }
    };

    return (

        <div
            role="button"
            tabIndex="0"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                width: "30%"
            }}


        >
            <div style={{ lineHeight: "1.5", flex: 1, fontFamily: 'Poppins' }}>
                {headers && headers.map((header, index) => (
                    <div key={index}>{header}</div>
                ))}
            </div>
            {
                colDef && colDef.sortable && (
                    <div style={{ display: "flex", flexDirection: "column", marginLeft: "8px" }}>
                        <Icon type="caret-up" style={{ color: sortOrder === "asc" ? "black" : "gray" }}
                            onClick={() => {
                                if (handleSort && field) {
                                    handleSort(field, "asc")
                                }
                            }
                            }
                            onTouchEnd={() => handleSort && field && handleSort(field, "asc")} />
                        <Icon type="caret-down" style={{ color: sortOrder === "desc" ? "black" : "gray", marginTop: '-5px' }}
                            onClick={() => {
                                if (handleSort && field) {
                                    handleSort(field, "desc")
                                }
                            }
                            }
                            onTouchEnd={() => handleSort && field && handleSort(field, "desc")} />
                    </div>
                )
            }
            <Popover
                content={filterContent}
                trigger="click"
                visible={visible}
                onVisibleChange={setVisible}
                placement="topLeft"
                // getPopupContainer={() => document.querySelector('.ag-center-cols-viewport') || document.body}  
                getPopupContainer={triggerNode => {
                    let node = triggerNode;
                    while (node && node !== document.body) {
                        if (
                            node.classList &&
                            node.classList.contains('ant-card-body')
                        ) {
                            return node;
                        }
                        node = node.parentNode;
                    }
                    return document.body;
                }}
                overlayStyle={{
                    zIndex: 3000,
                    padding: 8,
                    minWidth: 200,
                    maxWidth: 300,
                    pointerEvents: 'auto'
                }}
            >
                {
                    showPopOver && (
                        <Icon
                            type="filter"
                            style={{ marginLeft: 8, cursor: "pointer", color: filterValue ? '#1890ff' : 'gray' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setVisible(!visible);
                            }}
                            onTouchEnd={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setVisible(!visible);
                            }
                            }
                        />
                    )
                }

            </Popover>

        </div >
    );
}

export default CustomHeader




// WEBPACK FOOTER //
// ./src/CommonHeader/CustomHeader.js